import { render, staticRenderFns } from "./AuctionCollectionInformationLink.vue?vue&type=template&id=407e480d&scoped=true"
import script from "./AuctionCollectionInformationLink.vue?vue&type=script&lang=js"
export * from "./AuctionCollectionInformationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e480d",
  null
  
)

export default component.exports